/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React from 'react';
import Style from './EnergiaSolarPassoAPasso.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import CustomEmblaCarouselHome24 from '../CustomEmblaCarouselHome24';

function EnergiaSolarPassoAPasso() {
  return (
    <>
      <section id="energia-solar-passo-a-passo">
        <ContainerHome24>
          <h3 className="passo-a-passo-titulo">Como funciona a energia solar em 4 passos</h3>
          <div className="passo-a-passo-carrossel">
            <CustomEmblaCarouselHome24
              // loop
              enableBullets
              detectBulletCount
              //hideOverflow
              enableMobileArrows
              enablePrevArrow
              //autoplay={100000}
            >
              {({ className }) => (
                <>
                  <div className={`slide ${className}`}>
                    <p className="slide-numero">1</p>
                    <div className="slide-textos">
                      <p className="slide-titulo">Primeiro passo</p>
                      <p className="slide-texto">
                        Os painéis solares captam os raios do sol e os transformam em energia
                        elétrica.
                      </p>
                    </div>
                  </div>
                  <div className={`slide ${className}`}>
                    <p className="slide-numero">2</p>
                    <div className="slide-textos">
                      <p className="slide-titulo">Segundo passo</p>
                      <p className="slide-texto">
                        A energia é enviada para o inversor, que transforma essa energia em Corrente
                        Alternada, compatível com sua rede elétrica.
                      </p>
                    </div>
                  </div>
                  <div className={`slide ${className}`}>
                    <p className="slide-numero">3</p>
                    <div className="slide-textos">
                      <p className="slide-titulo">Terceiro passo</p>
                      <p className="slide-texto">
                        Após a instalação, a concessionária troca o seu relógio de energia por um
                        bidirecional, que registra o seu consumo de energia.
                      </p>
                    </div>
                  </div>
                  <div className={`slide ${className}`}>
                    <p className="slide-numero">4</p>
                    <div className="slide-textos">
                      <p className="slide-titulo">Quarto passo</p>
                      <p className="slide-texto">
                        No mês, caso a energia consumida seja menor do que a energia gerada, você
                        acumula créditos para os meses seguintes.
                      </p>
                    </div>
                  </div>
                </>
              )}
            </CustomEmblaCarouselHome24>
          </div>
        </ContainerHome24>
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default EnergiaSolarPassoAPasso;
